import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/version/index.js
// module id = 1416
// module chunks = 0